import React, { useState, useEffect, useContext } from "react";
import { Paper, TextareaAutosize } from "@mui/material";
import { MdManageAccounts } from "react-icons/md";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import './../../Style/InsertRent.scss'
import axios from "axios";
import { ApiLink } from '../../APILink/ApiLink';
import authHeader from '../../Auth/authHeader';
import LoginUserDetailed from '../../Auth/LoginUserDetailed';
import { errorAlert, handleSuccess } from '../../Components/Alerts';
import MenuItem from '@mui/material/MenuItem';
import { Month } from "../../OtherData/Month";
import { FaTimes } from "react-icons/fa";
import InsertTenants from "../Tenants/InsertTenants";
import Autocomplete from "@mui/material/Autocomplete";
import { getUnitID } from "../../Auth/GetUnitCompany";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import { LinkAndClickButton } from "../../Components/AddElementsButton";
import { HeaderPaperComponent } from "../../Components/HeaderPaperComponent";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import CircularProgress from '@mui/material/CircularProgress';

function InsertOfficialRent(props) {
    const TranscationData = [
        {
            id: 1,
            type: "Vendor"
        },
        {
            id: 2,
            type: "Ndërkombëtar"
        },
    ]

    const headers = authHeader();
    const email = LoginUserDetailed();
    const { fiscalYear } = useContext(FiscalYearContext);

    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');

    useEffect(() => {
        setMinDate(`${fiscalYear}-01-01`);
        setMaxDate(`${fiscalYear}-12-31`);
    }, [fiscalYear])

    const [date, setDate] = useState("");
    const [payDate, setPayDate] = useState("");
    const [invoiceNR, setInvoiceNR] = useState("");
    const [tenantsID, setTenantsID] = useState("");
    const [netoRent, setNetoRent] = useState(0);
    const [vat9, setVat9] = useState(0)
    const [brutoRent, setBrutoRent] = useState(0);
    const [vat, setVat] = useState(0);
    const [valueWithVAT, setValueWithVAT] = useState(0);
    const [payValue, setPayValue] = useState(0);
    const [coment, setComent] = useState("");
    const [paymentOptions, setPaymentOptions] = useState("");
    const [transactionType, setTransactionType] = useState(1);
    const [unId, setUnID] = useState('')

    const [tenants, setTenants] = useState([]);

    const [cashRegister, setCashRegister] = useState([]);
    const [insertingTransaction, setInsertingTransaction] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        setInsertingTransaction(true);
        if (!invoiceNR) {
            errorAlert("Ju lutem zgjedhni muajin!");
            setInsertingTransaction(false);
            return;
        }
        if (!tenantsID) {
            errorAlert("Ju lutem zgjedhni Qiradhënësin!");
            setInsertingTransaction(false);
            return;
        }
        if (!paymentOptions) {
            errorAlert("Ju lutem zgjedhni mënyrën e pagesës!");
            setInsertingTransaction(false);
            return;
        }
        if (!netoRent || !brutoRent) {
            errorAlert("Ju lutem plotesoni njërën nga fushat Bruto ose Neto");
            setInsertingTransaction(false);
            return;
        }
        const stateDate = {
            Date: date,
            PayDate: payDate,
            ActionType: "RNE",
            InvoiceNr: invoiceNR,
            SupplierID: tenantsID,
            Amount0: netoRent,
            Amount8: vat9,
            Amount18: brutoRent,
            Total: payValue,
            PaymentOptions: paymentOptions,
            TransactionType: transactionType,
            CompanyUnitID: unId > 0 ? unId : null,
            Coment: coment,
            CreatedByUser: email,
        };
        axios.post(ApiLink.API_URL + 'Rent/officialRent', stateDate, { headers })
            .then(() => {
                handleSuccess("Qiraja u shtua me sukses");
                setDate("");
                setPayDate("");
                setInvoiceNR("");
                setTenantsID("");
                // setAmount0(0);
                setNetoRent(0);
                setVat9(0);
                setBrutoRent(0);
                setVat(0);
                setValueWithVAT(0);
                setPayValue(0);
                setPaymentOptions("");
                setTransactionType(1);
                // setTenantsName("");
                setComent("");
                setfield(null);
                setInsertingTransaction(false);

            })
            .catch((error) => {
                setInsertingTransaction(false);
                // console.error(error);
                if (error.response && error.response.status === 409) {
                    setInsertingTransaction(false);
                    errorAlert(error.response.data);
                } else {
                    setInsertingTransaction(false);
                    // errorAlert("An unknown error occurred while processing the request.");
                }
            });
    }

    const fetchTenants = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', { headers, params: { ledger: 308 } });
            setTenants(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchPaymentType = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/paymenttype', { headers });
            setCashRegister(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const calculateNeto = async (brutoValue) => {
        try {
            const tatimiNeQira = Number(brutoValue) * (Number(9) / Number(100));
            const qirajaNeto = Number(brutoValue) - Number(tatimiNeQira);
            const vat = (Number(brutoValue) * 18) / 100;
            const totalWithVAt = Number(brutoValue) + Number(vat);
            const payVal = Number(totalWithVAt) - Number(tatimiNeQira);

            setNetoRent(qirajaNeto);
            setVat9(tatimiNeQira);
            setVat(vat);
            setValueWithVAT(totalWithVAt);
            setPayValue(payVal)
        } catch (error) {
            console.error("Error during calculation:", error);
            // Perform any necessary error handling here
        }
    };

    const calculateBruto = async (netoValue) => {
        try {
            const brutoRent = Number(netoValue) / Number(0.91);
            const tatimiNeQira = Number(brutoRent) - Number(netoValue);
            const vat = (Number(brutoRent) * 18) / 100;
            const totalWithVAt = Number(brutoRent) + Number(vat);
            const payVal = Number(totalWithVAt) - Number(tatimiNeQira);

            setBrutoRent(brutoRent);
            setVat9(tatimiNeQira);
            setVat(vat);
            setValueWithVAT(totalWithVAt);
            setPayValue(payVal)
        } catch (error) {
            console.error("Error during calculation:", error);
            // Perform any necessary error handling here
        }
    };

    const calculateFromVleraWithVAT = async (valueWithVAT) => {
        try {
            const brutoRent = (Number(valueWithVAT) * Number(100)) / Number(118);
            const vat9 = (Number(brutoRent) * Number(9)) / Number(100)
            const qirajaNeto = Number(brutoRent) - Number(vat9);
            const vat = Number(valueWithVAT) - Number(brutoRent);
            const payValue = Number(valueWithVAT) - Number(vat9);

            setNetoRent(qirajaNeto);
            setBrutoRent(brutoRent);
            setVat9(vat9)
            setVat(vat);
            setPayValue(payValue);
        } catch (error) {
            console.error("Error during calculation:", error);
            // Perform any necessary error handling here
        }
    };

    //Pjesa per select input field tenant
    const [field, setfield] = useState(null);
    const handleAutocompleteChangeTenants = (event, value) => {
        if (value && value.AccountID) {
            setTenantsID(value.AccountID);
            setfield(value); // Përditëso `selectedArticle` me vlerën e zgjedhur


        } else {
            // Në rast se vlera është pastruar
            setTenantsID(""); // Vendos vlerën e ArticleID në null
            setfield(null);  // Pastro `Autocomplete`

        }
    };

    const defaultPropsTenants = {
        options: tenants,
        getOptionLabel: (option) =>
            `${option.IdentificationNumber} - ${option.AccountName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid var(--dg-border)" }}>
                    <span>
                        {option.IdentificationNumber}<br />
                        {option.AccountName}
                    </span>
                    {/* <button
                          onClick={(e) => {
                              e.stopPropagation();
                              // handleButtonClick(option);
                          }}
                          onMouseEnter={handleOpen}
                          onMouseLeave={handleClose}
                          style={{ marginLeft: 'auto' }}
                      >
                          Click
                      </button> */}
                </li>
            </>
        ),
    };
    //////
    const getLastDateOfMonth = (year, month) => {
        // Muaji është 0-indexed në JavaScript
        const lastDay = new Date(year, month, 0).getDate();

        // Sigurohemi që muaji dhe dita janë të dy 2-shifror
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = lastDay < 10 ? `0${lastDay}` : lastDay;
        // Formatojmë datën në 'yyyy-MM-dd'
        const newDate = `${year}-${formattedMonth}-${formattedDay}`;

        setDate(newDate);
        setPayDate(newDate);
    };

    useEffect(() => {
        if (invoiceNR) {
            const dashIndex = invoiceNR.indexOf('-');
            const selectedMonth = parseInt(invoiceNR.substring(dashIndex + 1, dashIndex + 3));
            getLastDateOfMonth(fiscalYear, selectedMonth);
        }
    }, [invoiceNR, fiscalYear]);

    useEffect(() => {
        getUnitID(headers).then(setUnID);
    }, [headers])

    useEffect(() => {
        // fetchrent();
        fetchTenants();
        fetchPaymentType();
    }, [])

    return (
        <div className="Rent__Container">
            <TitleElements
                icon={MdManageAccounts}
                title="Qira e re nga personi juridik"
            />
            <ElementsParagraph text="Ju lutemi vini re se të gjitha te dhenat ruhen automatikisht në bazën e të dhënave për të pasur siguri në cdo hap!" />

            <hr></hr>
            <div className="Rent__Container__AllButtons">
                <div style={{ display: "flex", }}>
                    <InsertTenants fetchData={fetchTenants} type="insert" />
                </div>
                <div style={{ display: "flex" }}>
                    <div style={{ marginLeft: "5px" }}>
                        {insertingTransaction ? (
                            <button
                                className="button-15"
                                style={{ background: "var(--dg-header-gradient)" }}
                            >
                                <CircularProgress style={{ color: "var(--dg-header-text)", width: "20px", height: "20px" }} />
                            </button>
                        ) : (
                            <LinkAndClickButton
                                text="Ruaj & Ri"
                                link="#"
                                onClick={handleSubmit}
                            />
                        )}
                    </div>
                    <div style={{ marginLeft: "5px" }}>
                        <LinkAndClickButton
                            text="Mbyll"
                            icon={<FaTimes />}
                            link="/expences/rent"
                        />
                    </div>
                </div>
            </div>
            {/* <div className='header_paper2'></div> */}
            <HeaderPaperComponent />
            <form className='Rent__Container__Format'>
                <Paper className="rent-form-paper">
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div className='Forma1'>
                            <div className='Boxx'>
                                {/* <TextField
                                    className="AddPurchaseTotal__Container__Format__SameInput"
                                    // style={{ width: "594px" }}                                    id="invoiceNR"
                                    select
                                    label="Muaji"
                                    defaultValue=""
                                    value={invoiceNR}
                                    onChange={event => setInvoiceNR(event.target.value)}
                                    required
                                >
                                    {Month.map((data) => (
                                        <MenuItem key={data.id} value={fiscalYear + data.month}>{fiscalYear}{data.month}
                                        </MenuItem>
                                    ))}
                                </TextField> */}

                                <TextField
                                    // style={{ width: "150px" }}
                                    className="AddPurchaseTotal__Container__Format__SameInput"
                                    id="InvoiceNr"
                                    label="Numri Faturës"
                                    variant="outlined"
                                    name='InvoiceNr'
                                    value={invoiceNR}
                                    onChange={event => setInvoiceNR(event.target.value)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }} />


                                <div className='AddPurchaseTotal__Container__Format__Dates'>
                                    <TextField
                                        className="AddPurchaseTotal__Container__Format__Date"
                                        id="date"
                                        type="date"
                                        variant="outlined"
                                        name='Date'
                                        label="Data"
                                        value={date}
                                        onChange={(e) => { setDate(e.target.value); setPayDate(e.target.value) }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        inputProps={{
                                            min: minDate, // Kufizimi minimal i datës
                                            max: maxDate, // Kufizimi maksimal i datës
                                        }}
                                    />

                                    <TextField
                                        className="AddPurchaseTotal__Container__Format__Date"
                                        id="PayDate"
                                        type="date"
                                        variant="outlined"
                                        name='PayDate'
                                        label="Data pagesës"
                                        value={payDate}
                                        onChange={(e) => setPayDate(e.target.value)}
                                        required
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className="textfield_button">
                                    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                        <Autocomplete
                                            fullWidth
                                            componentsProps={{ paper: { className: "rent-autocomplete-paper" } }}
                                            {...defaultPropsTenants}
                                            id="include-input-in-list"
                                            includeInputInList
                                            value={field}  // Lidheni me state-in `selectedArticle`
                                            onChange={handleAutocompleteChangeTenants}
                                            isOptionEqualToValue={(option, value) => option.AccountID === value.AccountID} // Shto funksionin isOptionEqualToValue
                                            renderInput={(params) => (
                                                <TextField
                                                    className="AddPurchaseTotal__Container__Format__SameInput"

                                                    {...params}
                                                    label="Përzgjedh Qiradhënësin"
                                                // variant="filled"
                                                //   onKeyPress={handleKeyPress}
                                                />
                                            )}
                                            ListboxProps={{
                                                style: {
                                                    maxHeight: '200px', // Caktoni një lartësi maksimale për të lejuar vetëm 4 elemente
                                                    overflow: 'auto',   // Aktivizoni scroll-in për pjesën tjetër
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="AddPurchaseTotal__Container__Format__Dates" style={{ paddingTop: "10px" }}>
                                    <TextField
                                        // style={{ width: "593px" }}
                                        className="AddPurchaseTotal__Container__Format__Date"
                                        id="AccountID"
                                        label="Klasa e shpenzimit"
                                        defaultValue=""
                                        value={"308-Qiraja e Pagueshme"}
                                        // onChange={event => setAccountID(703)}
                                        disabled
                                    >
                                    </TextField>

                                    <TextField
                                        className="AddPurchaseTotal__Container__Format__Date"
                                        id="id"
                                        select
                                        label="Lloji qirasë"
                                        defaultValue=""
                                        value={transactionType}
                                        onChange={event => setTransactionType(event.target.value)}
                                        required
                                    >
                                        {TranscationData.map((data) => (
                                            <MenuItem key={data.id} value={data.id}>{data.type}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </div>

                                <TextField
                                    // style={{ width: "593px" }}
                                    className="AddPurchaseTotal__Container__Format__SameInput"
                                    id="PaymentType"
                                    select
                                    label="Përzgjedh llojin e pagesës"
                                    defaultValue=""
                                    // helperText="Please select expense"
                                    value={paymentOptions}
                                    onChange={event => setPaymentOptions(event.target.value)}
                                >
                                    <MenuItem key="0" value="0">Pagesa Behet më vonë
                                    </MenuItem>
                                    {cashRegister.map((data) => (
                                        <MenuItem key={data.AccountID} value={data.AccountID}>{data.AccountName}
                                        </MenuItem>
                                    ))}
                                </TextField>

                                <TextareaAutosize
                                    style={{ height: "70px", marginLeft: "10px" }}
                                    className="AddPurchaseTotal__Container__Format__SameInput"
                                    id="Comment"
                                    label="Komenti"
                                    type="text"
                                    name='Comment'
                                    value={coment}
                                    onChange={event => setComent(event.target.value)}
                                    variant="outlined"
                                    autoComplete="off"
                                />
                            </div>
                            <div className='box2'>
                                <div className='box3'>
                                    <TextField
                                        // style={{ width: "150px" }}
                                        className="AddPurchaseTotal__Container__Format__ValueInput"
                                        id="outlined-basic"
                                        label="Qiraja Neto"
                                        variant="outlined"
                                        name='Amount8'
                                        value={netoRent !== null && netoRent !== 0 ? netoRent.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                        onChange={event => setNetoRent(event.target.value)}
                                        onKeyUp={event => calculateBruto(event.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }} />
                                </div>
                                <div className='box3'>
                                    <TextField
                                        // style={{ width: "150px" }}
                                        className="AddPurchaseTotal__Container__Format__ValueInput"
                                        id="outlined-basic"
                                        label="Tatimi në qira 9%"
                                        name='Amount18'
                                        variant="outlined"
                                        value={vat9 !== null && vat9 !== 0 ? vat9.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                        onChange={event => setVat9(event.target.value)}
                                        disabled
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className='box3' >
                                    <TextField
                                        // style={{ width: "150px" }}
                                        className="AddPurchaseTotal__Container__Format__ValueInput"
                                        id="outlined-basic"
                                        label="Qiraja Bruto [Vlera pa TVSH]"
                                        variant="outlined"
                                        name='Total'
                                        value={brutoRent !== null && brutoRent !== 0 ? brutoRent.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                        onChange={event => setBrutoRent(event.target.value)}
                                        onKeyUp={event => calculateNeto(event.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className='box3' style={{ paddingTop: "10px" }}
                                >
                                    <TextField
                                        className="AddPurchaseTotal__Container__Format__ValueInput"
                                        id="VAT"
                                        label="TVSH"
                                        variant="outlined"
                                        name='VAT'
                                        value={vat !== null && vat !== 0 ? vat.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                        onChange={event => setVat(event.target.value)}
                                        disabled
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className='box3' >
                                    <TextField
                                        // style={{ width: "150px" }}
                                        className="AddPurchaseTotal__Container__Format__ValueInput"
                                        id="ValueWithVAT"
                                        label="Vlera me TVSH"
                                        variant="outlined"
                                        name='ValueWithVAT'
                                        value={valueWithVAT !== null && valueWithVAT !== 0 ? valueWithVAT.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                        onChange={event => setValueWithVAT(event.target.value)}
                                        onKeyUp={event => calculateFromVleraWithVAT(event.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className='box3' >
                                    <TextField
                                        // style={{ width: "150px" }}
                                        className="AddPurchaseTotal__Container__Format__ValueInput"
                                        id="PayValue"
                                        label="Vlera per Pagese"
                                        variant="outlined"
                                        name='PayValue'
                                        value={payValue !== null && payValue !== 0 ? payValue.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'}
                                        onChange={event => setPayValue(event.target.value)}
                                        disabled
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>

                            </div>
                        </div>

                    </Box>
                </Paper>
            </form>
            <div></div>
        </div>
    );
}
export default InsertOfficialRent;
